






















































































































































































































































































































import AtTerminalLocationDialog from "./TerminalLocationDialog.vue";
import AtRegistrationReport from "./LocationRegistrationReport.vue";
import AtAreadefinition from "./Areadefinition.vue";
import RegWithoutTerminalInfoDialog from "./RegWithoutTerminalInfoDialog.vue";
import Routes from "../../modules/Routes";
import {
  ApiMessage,
  companyroleid,
  HmsregLocationStatus,
  HseGuideline,
  locationroleid,
  Terminal,
  TerminalConfigNext,
  TerminalGuiInfo,
  TerminalLocation,
  TerminalLocationExportserviceInfo,
  TerminalLocationHmsregInfo,
  TerminalLocationRegcode
} from "../../modules/models";
import {Component, Inject, Prop, Watch} from "vue-property-decorator";
import Api from "./Api";
import rd from "../../modules/vRoutedefs";
import UserRequired from "../UserRequired";
import RegcodeDisplay from "@/components/location/RegcodeDisplay.vue";
import RegcodeInfoText from "@/components/location/RegcodeInfoText.vue";
import InfoDialog from "@/components/InfoDialog.vue";
import RegWithoutCardInfoText from "@/components/location/RegWithoutCardInfoText.vue";
import InvoicingInfo from "@/components/location/InvoicingInfo.vue";
import RequireRegcodeInfoDialog from "@/components/location/RequireRegcodeInfoDialog.vue";
import LocationTerminalSet from "@/components/location/LocationTerminalSet.vue";
import SyncInfoDialog from "@/components/terminals/SyncInfoDialog.vue";
import BaseApi from "@/store/modules/base";
import InfoBtn from "@/components/shared/InfoBtn.vue";
import HseGuidelineDialog from "@/components/location/HseGuidelineDialog.vue";
import Ellipsifier from "@/components/shared/Ellipsifier.vue";
import ContactLink from "@/components/shared/ContactLink.vue";

@Component({
        components: {
            "at-terminal-location-dialog": AtTerminalLocationDialog,
            "at-registration-report": AtRegistrationReport,
            "at-areadefinition": AtAreadefinition,
            "at-without-terminal-info": RegWithoutTerminalInfoDialog,
            "at-regcode": RegcodeDisplay,
            "at-regcode-info": RegcodeInfoText,
            "at-info-dialog": InfoDialog,
            "at-rwoc-info": RegWithoutCardInfoText,
            "at-invoicing-info": InvoicingInfo,
            "at-require-regcode-dialog": RequireRegcodeInfoDialog,
            "at-location-terminal-set": LocationTerminalSet,
            "at-syncinfo-dialog": SyncInfoDialog,
            "at-info-btn": InfoBtn,
            "at-hseguideline-dlg": HseGuidelineDialog,
          "at-ellips": Ellipsifier,
          "at-contact-link": ContactLink,
        }
    })
    export default class Location extends UserRequired {
        @Prop()
        locationId!: number;

        @Inject()
        api!: Api;
        @Inject()
        baseApi!: BaseApi;

        location: TerminalLocation | null = null;
        get locationDescription() {
            return this.location != null ? this.location.description : null;
        }
        get address() {
            return this.location != null ? this.location.address : null;
        }
        get constructorName() {
            return this.location != null ? this.location.constructorName : null;
        }
        get invoiceRef() {
            return this.location != null ? this.location.invoiceRef : null;
        }
        get unverifiedRegsOk() {
            return this.location != null ? this.location.unverifiedRegsOk : false;
        }
        set unverifiedRegsOk(v: boolean) {
            if(this.location != null && v !== this.unverifiedRegsOk) {
                this.location.unverifiedRegsOk = v;
                this.updateLocation();
            }
        }
        showRegWithoutCardInfo = false;

        get companyOrgNum() {
            return this.location != null ? this.location.companyOrgNum : null;
        }
        get regWithoutTerminal() {
            return this.location != null ? this.location.regWithoutTerminal : false;
        }
        set regWithoutTerminal(v: boolean) {
            if(this.location != null && v !== this.regWithoutTerminal) {
                this.location.regWithoutTerminal = v;
                if(v) {
                    this.location.mobileRegGeoRequired = true;
                }
                this.updateLocation();
            }
        }
        terminalTo(terminalGuid: string) {
            return {name: rd.terminals.terminal.name, params: {guid: terminalGuid}};
        }
        pendingTerminalPageTo(guid: string) {
            return {name: rd.terminals.pending.name, params: {guid: guid}};
        }

        get requireRegcodeInit() {
            return this.location != null ? this.location.mobileRegRegcodeRequired : false;
        }
        set requireRegcodeInit(v: boolean) {
            if(this.location != null && this.location.mobileRegRegcodeRequired !== v) {
                if(v && !this.regcodes.some((rc) => rc.toTs === null)) {
                    this.mobileRegRequireErrors = ["Anleggskode må genereres først"];
                } else {
                    this.location.mobileRegRegcodeRequired = v;
                    if (!v && !this.location.mobileRegGeoRequired) {
                        this.mobileRegRequireErrors = ["Geoposisjonskontroll må være påkrevd før deaktivering"];
                    } else {
                        this.mobileRegRequireErrors = [];
                        this.updateLocation();
                    }
                }
            } else {
                this.mobileRegRequireErrors = [];
            }
        }
        showRequireRegcodeInitInfo = false;

        showRequireGeoInfo = false;
        requireGeoErrors: string[] = [];
        get requireGeo() {
            return this.location != null ? this.location.mobileRegGeoRequired : true;
        }
        set requireGeo(v: boolean) {
            if(this.location != null && this.location.mobileRegGeoRequired !== v) {
                if(!v && !this.location.mobileRegRegcodeRequired) {
                    this.requireGeoErrors = ["Anleggskode må være påkrevd før deaktivering"];
                } else {
                    this.requireGeoErrors = [];
                    this.location.mobileRegGeoRequired = v;
                    if (!v) {
                      // also turn off require geo on reg out
                      this.location.mobileRegOutGeoRequired = false;
                    }

                    this.updateLocation();
                }
            } else {
                this.requireGeoErrors = [];
            }
        }
        mobileRegRequireErrors: string[] = [];
        onRequireGeoChanged(newVal) {
          if(newVal) {
            this.showRequireGeoInfo = true;
          }
        }

        get onsiteTo() {
            return {path: rd.locations.location.onsite.paramPath(this.locationId)};
        }

        hmsregInfo: TerminalLocationHmsregInfo | null = null;
        hmsregLocationStatus: HmsregLocationStatus | null = null;
        exportserviceInfos: TerminalLocationExportserviceInfo[] = [];
        activeTerminals: Terminal[] = [];
        pendingConfigs: TerminalConfigNext[]= [];
        onsiteCount = 0;
        regcodes: TerminalLocationRegcode[] = [];

        get invoicingInfo() {
            if(this.location == null) {
                return 0;
            } else if(this.location.isShutdown) {
                return 1;
            } else {
                // If there is active terminal with licensetype < 3, the location is invoiced through that.
                if(this.activeTerminals.some((t: Terminal) => t.licenseType < 3)) {
                    return 2;
                } else {
                    return 3;
                }
            }
        }

        get terminalPoints() {
            return this.activeTerminals.filter((t) => t.geolocation != null).map((t) => t.geolocation);
        }

        @Watch("locationId", {immediate: true})
        async onLocationIdChange(n: number) {
            const locationP = await this.api.fetchTerminalLocation(n);
            this.location = locationP;
            if(this.location != null) {
                const hmsregInfoP = this.api.fetchHmsregInfo(n);
                const hmsregStatP = this.api.fetchHmsregLocationStatus(n);
                const hseGuidelineP = this.api.getHseGuideline(n);
                const exportserviceInfosP = this.api.fetchExportserviceInfos(this.location.companyOrgNum, n);
                const activeTerminalsP = this.api.fetchTerminalsActiveOnLocation(n);
                const onsiteCountP = this.api.fetchOnsiteCount(n);
                const regcodesP = this.api.fetchTerminalLocationRegcodes(n);
                const pendingConfigsP = this.api.fetchTerminalsPendingOnLocation(n);
                this.hmsregInfo = await hmsregInfoP;
                this.hmsregLocationStatus = await hmsregStatP;
                this.exportserviceInfos = await exportserviceInfosP;
                this.activeTerminals = await activeTerminalsP;
                this.onsiteCount = await onsiteCountP;
                this.regcodes = await regcodesP;
                this.pendingConfigs = await pendingConfigsP;
                this.hseGuideline = await hseGuidelineP;
                // Incase location is loaded from link belongs to company other than currently active, change to it.
                if (this.companyOrgNum != null && (this.baseApi.company == null || this.baseApi.company.orgNum !== this.companyOrgNum)) {
                    this.baseApi.loadCompany(this.companyOrgNum);
                }
            } else {
                throw new Error("Anlegg ikke funnet");
            }
        }

        editLocation() {
            if(this.location != null) {
                const el = this.$refs.editDialog;
                if (el instanceof AtTerminalLocationDialog) {
                    const dlg = el as AtTerminalLocationDialog;
                    dlg.open(this.location, this.hmsregInfo, this.exportserviceInfos);
                }
            }
        }
        async reloadLocation() {
            await this.onLocationIdChange(this.locationId);
        }
        locationCreated(msg: string) {
            this.snackMsg = msg;
            this.reloadLocation();
        }

        showRegWithoutTerminalInfo = false;
        onRegWithoutTerminalChanged(newVal) {
            if(newVal) {
                this.showRegWithoutTerminalInfo = true;
            }
        }


        get isShutdown() {
            return this.location != null && this.location.shutdownTime != null;
        }
        shutdownBlockedByTerminals = false;
        confirmShutdown = false;
        initShutdown() {
            if(this.location != null) {
                if(this.activeTerminals.length > 0) {
                    this.shutdownBlockedByTerminals = true;
                } else {
                    this.confirmShutdown = true;
                }
            }
        }

        snackMsg = "";
        get showSnack() {
            return this.snackMsg.length > 0;
        }
        set showSnack(v: boolean) {
            if(!v) {
                this.snackMsg = "";
            }
        }

        get allowRegcodeChange() {
            return this.location != null && (this.user.isCompanyAdmin(this.location.companyOrgNum) || this.user.isLocationAdmin(this.location.companyOrgNum, this.location.id));
        }
        regcodeWorking = false;
        async addRegcode() {
            try {
                if(this.location != null) {
                    this.regcodeWorking = true;
                    const resp = await this.api.createTerminalLocationRegcode(this.location.id);
                    if (resp instanceof ApiMessage) {
                        this.snackMsg = resp.msg;
                    } else {
                        this.regcodes = resp;
                        this.snackMsg = "Ny anleggskode lagt til";
                    }
                }
            } finally {
                this.regcodeWorking = false;
            }
        }
        async toggleRegcodeState(rc: TerminalLocationRegcode) {
            try {
                if(this.location != null) {
                    this.regcodeWorking = true;
                    const enable = rc.toTs != null;
                    this.regcodes = await this.api.setTerminalLocationRegcodeState(rc.id, enable);
                    this.snackMsg = `Anleggskode ${enable ? "aktivert" : "deaktivert"}`;
                }
            } finally {
                this.regcodeWorking = false;
            }
        }
        get mostRecentRegcode() {
            // Returned regcode list is sorted ascending by id, so most recent is always the last in the list
            if(this.regcodes.length > 0) {
                return this.regcodes[this.regcodes.length - 1];
            } else {
                return null;
            }
        }
        showRegcodeInfo = false;

        working = false;
        async shutdown() {
            if(this.location != null) {
                try {
                    this.working = true;
                    const msg = await this.api.terminalLocationShutdown(this.location.id);
                    this.snackMsg = msg.msg;
                    this.reloadLocation();
                } finally {
                    this.working = false;
                    this.confirmShutdown = false;
                }
            }
        }
        async activate() {
            if(this.location != null) {
                try {
                    this.working = true;
                    const msg = await this.api.terminalLocationActivate(this.location.id);
                    this.snackMsg = msg.msg;
                    this.reloadLocation();
                } finally {
                    this.working = false;
                }
            }
        }

        async updateLocation() {
            try {
                if(this.location != null) {
                    this.working = true;
                    await this.api.updateTerminalLocation(this.location);
                    await this.reloadLocation();
                }

            } catch(e) {
                try {
                    this.reloadLocation(); // To rollback preapplied data model changes that failed to apply on the server
                } catch (e) {
                    // Ignore if reload fails
                }
                this.emitError(e);
            } finally {
                this.working = false;
            }
        }

        // Create/get cached version of location poster pdf and display it to user allowing him to save/print it
        get locationPosterUrl() {
            return Routes.terminalLocationPosterPdf(this.locationId);
        }

        showLocationTerminalSet = false;
        companyTerminals: TerminalGuiInfo[] = [];
        get terminalsNotOnThis() {
            return this.companyTerminals.filter(t => this.terminalLocCheck(t) === 0);
        }
        // Returns 1 if terminal is currently on location, 2 if it is pending to be
        private terminalLocCheck(t: TerminalGuiInfo): number {
            if(t.location != null && t.location.id === this.locationId) {
                return 1;
            }
            if(t.nextConfig != null && t.nextConfig.location != null && t.nextConfig.location.id === this.locationId) {
                return 2;
            }
            return 0;
        }

        loadingTerminals = false;
        async openLocationTerminalSet() {
            try {
                this.loadingTerminals = true;
                if (this.location) {
                    if (this.companyTerminals.length === 0) {
                        this.companyTerminals = await this.api.fetchTerminals(this.location.companyOrgNum, false);
                    }
                    this.showLocationTerminalSet = true;
                }
            } finally {
                this.loadingTerminals = false;
            }
        }
        // When this is set, terminal sync dialog is shown, to get user to sync given terminal (after location setting)
        promptTerminalSyncGuid: string | null = null;
        get showTerminalSyncDialog() {
            return this.promptTerminalSyncGuid != null;
        }
        set showTerminalSyncDialog(v: boolean) {
            if(!v) {
                this.promptTerminalSyncGuid = null;
            }
        }

        terminalSet(ti: Terminal) {
            this.reloadLocation();
            this.promptTerminalSyncGuid = ti.guid;
        }

        showRequirePhoneAuthInfo = false;
        get requirePhoneAuth(): boolean {
            return !!this.location && this.location.requirePhoneAuth;
        }
        set requirePhoneAuth(v: boolean) {
            if(this.location != null && this.location.requirePhoneAuth != v) {
                this.location.requirePhoneAuth = v;
                this.updateLocation();
            }
        }

        showHmsregStatus = false;

        get hmsregSettingspageTo() {
          return {name: rd.system.integrations.hmsreg.name};
        }

        showHseGuidelineInfo = false;
        hseGuideline: HseGuideline | null = null;
        showHseGuidelineDlg = false;

        async onHseGuidelineChanged() {
          if(this.location) {
            this.hseGuideline = await this.api.getHseGuideline(this.location.id);
          }
        }
        onHseGuidelineDeleted() {
          this.hseGuideline = null;
          this.emitSnack(`HMS retningslinje slettet`);
        }

        get hseGuidelineEnabled(): boolean {
          return !!this.location && this.location.hseGuidelineEnabled > 0;
        }
        set hseGuidelineEnabled(v: boolean) {
          if(this.location != null && this.hseGuidelineEnabled != v) {
            this.location.hseGuidelineEnabled = v ? 1 : 0;
            this.updateLocation();
          }
        }

        readonly hseGuidelineDocTo = rd.docs.hseguidelines.path;

        get confirmedHseGuidelineReportTo() {
          return {name: rd.locations.location.confirmedHseGuidelineReport.name, params: {locationId: this.locationId}};
        }

        get terminalsAppVersionTooOldForHse() {
          return this.activeTerminals.filter(t => t.appVersion < 95 /* min version that has hse guideline confirm */)
        }
        showTerminalAppVersionTooOldDlg = false;

        readonly roleDocTo = rd.docs.roleinfo.path;

        get isLocationAdmin(): boolean {
          if(this.companyOrgNum) {
            return this.user.isCompanyAdmin(this.companyOrgNum) || this.user.isLocationAdmin(this.companyOrgNum, this.locationId);
          }
          return false;
        }

        get editsDisabled(): boolean {
          return this.location != null && !this.isLocationAdmin;
        }

        get showReport(): boolean {
          const usr = this.baseApi.user;
          if(usr && this.companyOrgNum) {
            return usr.hasAnyCompanyRoleType([companyroleid.admin, companyroleid.reporter, companyroleid.super], this.companyOrgNum) ||
                usr.hasAnyLocationRoleType([locationroleid.admin, locationroleid.reporter], this.companyOrgNum, this.locationId);
          }
          return false;
        }

        get mobileRegOutGeoRequired() {
          return this.location != null ? this.location.mobileRegOutGeoRequired : true;
        }
        set mobileRegOutGeoRequired(v: boolean) {
          if(this.location != null && v !== this.mobileRegOutGeoRequired) {
            this.location.mobileRegOutGeoRequired = v;
            this.updateLocation();
          }
        }

        showAllowRegOutMobileInfo = false;
        get allowRegOutMobile() {
          return this.location != null ? this.location.allowRegOutMobile : true;
        }
        set allowRegOutMobile(v: boolean) {
          if(this.location != null && v !== this.allowRegOutMobile) {
            this.location.allowRegOutMobile = v;
            this.updateLocation();
          }
        }
    }
